/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */

import { Component, OnInit, Input } from '@angular/core';
import { UserProfileResponse } from '../../../../view/userprofile/userprofileresponse';
import { UserProfileService } from '../../../../view/userprofile/userprofile.service';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'zsd-additionalinfo',
  templateUrl: '../../view/additionalinfo/additionalinfo.component.html',
  styleUrls: ['../../view/additionalinfo/additionalinfo.component.scss']
})
export class AdditionalinfoComponent implements OnInit {
  @Input('parentForm') public parentForm: FormGroup;

  lineManager;
  location;
  additionalInfoForm: FormGroup;
  @Input('showLineManager') showLineManager = true;

  constructor(private userProfileService: UserProfileService, public formBuilder: FormBuilder) {

  }

  ngOnInit() {
    this.additionalInfoForm = this.formBuilder.group({
      location: this.formBuilder.control(''),
    });
    if (this.parentForm) {
      this.parentForm.addControl('additionalInfo', this.additionalInfoForm);
    }
    this.userProfileService.getUserprofile().subscribe(
      (addinfo: UserProfileResponse) => {
        this.lineManager = addinfo.lineManagerFullName;
        this.location = addinfo.city;

        this.additionalInfoForm.get('location').setValue(this.location);
        this.additionalInfoForm.updateValueAndValidity();
        this.parentForm.setControl('additionalInfo', this.additionalInfoForm);
      },
      () => {
        return null;
      }
    );

  }

}
